import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogContent, DialogTitle, Button, TextField, Box} from 'views/components';
import {Translate, CaregiverAutocomplete, translate} from 'views/module';

const ChangeCaregiver = (props) => {
  const {closeModel, event, onUpdateEventCaregiver} = props;

  const [pendingCaregiver, setPendingCaregiver] = React.useState(null);
  const [reason, setReason] = React.useState('');
  const [isSaving, setIsSaving] = React.useState(false);

  const onSave = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    if (!pendingCaregiver || !pendingCaregiver.caregiverRn) {
      setIsSaving(false);
      return;
    }
    const reasonForException = {
      description: {
        blob: reason,
        editorType: 'MARKDOWN',
      },
    };
    const caregiverData = {
      caregiverRn: pendingCaregiver.caregiverRn,
    };
    await onUpdateEventCaregiver(
        event.clientData.clientRn,
        event.eventRn,
        caregiverData,
        reasonForException,
        () => {
          closeModel(true);
          setIsSaving(false);
        },
    );
  };

  const onClose = () => {
    closeModel(false);
  };

  return (
    <Dialog onClose={onClose} open={true} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Translate expression='schedule.eventDetail.UserSection.Caregiver.ChangeCaregiver' />
      </DialogTitle>
      <DialogContent sx={{overflow: 'visible'}}>
        <CaregiverAutocomplete
          label={translate('client.ClientDetail.Scheduling.ScheduleDetail.Caregiver.CaregiverSearch')}
          selectedCaregiver={pendingCaregiver}
          setSelectedCaregiver={setPendingCaregiver}
        />
        <TextField
          label={translate('schedule.eventDetail.Reason.Reason')}
          value={reason}
          onChange={(e) => setReason(e)}
          fullWidth
          size="small"
          placeholder={translate('schedule.eventDetail.Reason.ReasonForCaregiver')}
          multiline
          minRows={3}
          sx={{mt: 2}}
        />
        <Box sx={{display: 'flex', justifyContent: 'flex-end', mt: 2, gap: 1}}>
          <Button variant="outlined" onClick={onClose}>
            <Translate expression="generic.Cancel" />
          </Button>
          <Button variant="contained" onClick={onSave} disabled={isSaving || !pendingCaregiver}>
            <Translate expression="generic.Save" />
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

ChangeCaregiver.propTypes = {
  closeModel: PropTypes.func.isRequired,
  event: PropTypes.object.isRequired,
  onUpdateEventCaregiver: PropTypes.func.isRequired,
};

export default ChangeCaregiver;
